/**
 * Weights, lookup tables and bank code lists used by the per bank account check digit rules.
 * The weights come from the "Regras de Validação de dígito verificador de agência e conta
 * corrente" compendium and were cross checked against independent open source validators.
 *
 * @see Based on: https://github.com/eduardokum/laravel-boleto/blob/master/manuais/Regras%20Validacao%20Conta%20Corrente%20VI_EPS.pdf
 * Icatu Seguros compendium of per bank agency/account check digit rules, mirrored in this repo.
 * @see Based on: https://github.com/ajmiciano/banktools-br/tree/master/lib/banktools-br/banks
 * @see Based on: https://github.com/luizalabs/heimdall/blob/main/heimdall_valid_bank/calculate_number_account.py
 * @see Based on: https://github.com/Xerpa/bran_checker/tree/master/lib/banks
 */

export const COMPE_CODES =
	"001003004007010011012014015016017018021023024025033036037040041047060063064065066069070074" +
	"075076077078079080081082083084085088089093094095096097099100101102104105107111113119120121" +
	"122124125126127128129130131132133134136138139140141142143144145146149157159173174180183188" +
	"189190191194195196197208212213217218222224233237241243246249250254259260265266268269271272" +
	"273274276278280281283288289290292293296298299300301305307310312318319320321322323324326329" +
	"330331332334335336341342348349350352355358359360362363364365366368370373374376377378379380" +
	"381382383384385386387389390391393394395396397398399400401402403404406407408410411412413414" +
	"415416418419421422423425426427428430433435438439440443444445447448449450451452454455456457" +
	"458460461462463464465467468469470473475476477478479481482484487488495496505506507508509510" +
	"511512513514516517518519520521522523524525526527528529530531532533534535536537538539540541" +
	"542543544546547548550551552553554555556557559560561562563564565566567568569571572573574575" +
	"576577579585586587588589590591592593594595596597598599600604610611612613614615619620623626" +
	"630632633634636637643644646651653654655659660661662663665668669670671672673674675676677678" +
	"679680681682683684685686687688690691692693694695696697698699700701703704707708712714719741" +
	"743745747748751752753754755756757759760761763764765766767768769770771772773774775778780781" +
	"783785786787788789790791792793794795804";

export const SANTANDER_WEIGHTS = [9, 7, 3, 1, 0, 0, 9, 7, 1, 3, 1, 9, 7, 3];

export const BANRISUL_ACCOUNT_WEIGHTS = [3, 2, 4, 7, 6, 5, 4, 3, 2];

export const HSBC_AGENCY_ACCOUNT_WEIGHTS = [8, 9, 2, 3, 4, 5, 6, 7, 8, 9];

export const CITIBANK_ACCOUNT_WEIGHTS = [11, 10, 9, 8, 7, 6, 5, 4, 3, 2];

export const VERHOEFF_MULTIPLICATION = [
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
	[1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
	[2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
	[3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
	[4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
	[5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
	[6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
	[7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
	[8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
	[9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
];

export const VERHOEFF_PERMUTATION = [
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
	[1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
	[5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
	[8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
	[9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
	[4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
	[2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
	[7, 0, 4, 6, 9, 1, 3, 2, 5, 8],
];

export const VERHOEFF_INVERSE = [0, 4, 3, 2, 1, 5, 6, 7, 8, 9];

export const STRUCTURE_ONLY_BANK_CODES = [
	"077",
	"085",
	"102",
	"136",
	"197",
	"208",
	"212",
	"290",
	"318",
	"323",
	"336",
	"380",
	"403",
	"623",
	"655",
	"707",
	"748",
	"756",
];
